import moment from 'moment';
import { IPreviewPublicationRequest } from '../../../../model/sdp/official-daily/request/preview-publication-request';
import { IPreviewPublicationResponse } from '../../../../model/sdp/official-daily/response/preview-publication-response';

export type OfficialDiaryPublicationState = {
  activeStep: number;
  files: File[];
  completed: { [k: number]: boolean };
  previewPublicationRequest: IPreviewPublicationRequest;
  previewPublicationResponse: IPreviewPublicationResponse;
  loading: boolean;
};

export enum ACTION_TYPES {
  setActiveStep = 'setActiveStep',
  setFiles = 'setFiles',
  setCompleted = 'setCompleted',
  setPreviewPublicationRequest = 'setPreviewPublicationRequest',
  setPreviewPublicationResponse = 'setPreviewPublicationResponse',
  setLoading = 'setLoading',
  resetForm = 'resetForm',
}

export const OfficialDiaryPublicationReducer = (state: OfficialDiaryPublicationState, action: any): OfficialDiaryPublicationState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setActiveStep:
      return {
        ...state,
        activeStep: payload,
      };
    case ACTION_TYPES.setFiles:
      return {
        ...state,
        files: payload,
      };
    case ACTION_TYPES.setCompleted:
      return {
        ...state,
        completed: payload,
      };
    case ACTION_TYPES.setPreviewPublicationRequest:
      return {
        ...state,
        previewPublicationRequest: payload,
      };
    case ACTION_TYPES.setPreviewPublicationResponse:
      return {
        ...state,
        previewPublicationResponse: payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    case ACTION_TYPES.resetForm:
      return {
        ...state,
        activeStep: 0,
        files: [],
        previewPublicationRequest: {
          ...state.previewPublicationRequest,
          republication: false,
          publicationDateOn: moment().format("YYYY-MM-DD"),
        } as IPreviewPublicationRequest,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
